const dashboardState = {
  isLoading: false,
  isCancelInProcess: false,
  experiments: {},
  needsToScheduleTimeSlot: null,
  orderSummary: {},
  paymentSummary: {},
  vehicleLock: {
    expiresOn: null,
    isAvailable: false
  },
  notifications: {},
  availableOptions: {
    needsToScheduleTimeSlot: false
  }
};

export default dashboardState;
